import { MeasureUploadZone } from './MeasureUploadZone';
import { MeasureLibraryTable } from './MeasureLibraryTable';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { useQueryClient } from '@tanstack/react-query';

export function MeasureManagement() {
  const queryClient = useQueryClient();

  const handleUploadComplete = () => {
    // Refresh the measures list after successful upload
    queryClient.invalidateQueries({ queryKey: ['measures'] });
  };

  return (
    <div className="space-y-6">
      {/* Upload Section */}
      <Card>
        <CardHeader>
          <CardTitle>Upload Measure Logic</CardTitle>
          <CardDescription>
            Upload JSON files containing CMS measure definitions and value sets.
            The system will automatically parse and store the measure logic for use in calculations.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <MeasureUploadZone onUploadComplete={handleUploadComplete} />
        </CardContent>
      </Card>

      <Separator />

      {/* Library Section */}
      <Card>
        <CardHeader>
          <CardTitle>Measure Library</CardTitle>
          <CardDescription>
            View and manage uploaded measure definitions. Active measures will be used for quality calculations.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <MeasureLibraryTable />
        </CardContent>
      </Card>
    </div>
  );
}


